/*
 * Created Date: 27-02-2024, 4:00:01 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Feb 28 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { workspaceAvatarUrl } from '@App/Studio/app-config/const'
import CurrentPlanLabel from '@Core/Components/Common/Plan/CurrentPlanLabel'
import CoreDialog from '@Core/Components/Dialog/CoreDialog'
import { LOCAL_STORAGE, getDataSession } from '@Core/Helpers/Session'
import { getS3Url } from '@Core/Helpers/Url'
import { useCoreAuthActions } from '@Core/Provider/CoreAuthProvider'
import { useCorePlanContext } from '@Core/Provider/CorePlanProvider'
import { useCoreWorkspaceContext } from '@Core/Provider/CoreWorkspaceProvider'
import { LoadingButton } from '@mui/lab'
import { Avatar, CircularProgress, TextField, Typography } from '@mui/material'
import clsx from 'clsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useSwitchWorkspaceDialog = props => {
	const [open, setOpen] = useState(false)
	const { myWorkspaces = [], switchWorkspace, fetchingWorkspaces, currentWorkspace } = useCoreWorkspaceContext()
	const { plans = [] } = useCorePlanContext()
	// const { switchWorkspace } = useCoreAuthActions()
	const [loadingId, setLoadingId] = useState(null)
	const [search, setSearch] = useState()
	const { t } = useTranslation()

	const handleOpen = () => {
		setOpen(true)
	}
	const handleClose = () => {
		setOpen(false)
	}

	// const workspaces = getDataSession(LOCAL_STORAGE, 'workspaces') ?? []
	// const currentWorkspace = getDataSession(LOCAL_STORAGE, 'current_workspace')

	const handleSwitch = async workspace_id => {
		setLoadingId(workspace_id)
		// // // const isSuccess = await switchWorkspace(id)
		// // if (isSuccess) {
		// 	handleClose()
		// }
		switchWorkspace(workspace_id).then(() => {
			handleClose()
		})
		setLoadingId(null)
	}

	const renderListWorkspace = () => {
		if (Array.isArray(myWorkspaces) && myWorkspaces?.length > 0) {
			return myWorkspaces
				.filter(i => (search ? i.name.indexOf(search) > -1 : true))
				.map(item => {
					const plan = plans?.find(i => i?.slug === item?.teamable?.current_plan) ?? {}
					return (
						<div className="flex items-center justify-between p-2" key={item.id}>
							<div className="flex items-center gap-2">
								<Avatar
									src={item?.teamable?.avatar ? getS3Url(item?.teamable?.avatar) : workspaceAvatarUrl}
									alt={item?.name}
									sizes={40}
								/>
								<div className={clsx('flex flex-col gap-1 truncate')}>
									<Typography variant="M14" className=" max-w-[150px] whitespace-pre-wrap">
										{item?.teamable?.name}
									</Typography>
									<CurrentPlanLabel currentPlan={plan} />
								</div>
							</div>
							<LoadingButton
								loading={item?.id === loadingId}
								onClick={() => handleSwitch(item?.id)}
								variant="contained"
								size="small"
								gradient="secondary"
								disableElevation
								disabled={currentWorkspace?.id === item?.id}
							>
								{t('Truy cập')}
							</LoadingButton>
						</div>
					)
				})
		}
	}

	const render = () => {
		return (
			<CoreDialog
				open={open}
				handleClose={handleClose}
				dialogTitle={
					<div className="flex flex-col gap-2">
						<Typography>{t('Switch workspace')}</Typography>
						<div>
							<TextField
								fullWidth
								size="small"
								placeholder={t('Tìm kiếm workspace')}
								onChange={e => setSearch(e.target.value)}
							/>
						</div>
					</div>
				}
				dialogContent={
					fetchingWorkspaces ? (
						<div className="mt-20 text-center">
							<CircularProgress />
						</div>
					) : (
						<div className="grid grid-cols-1 gap-4 ">{renderListWorkspace()}</div>
					)
				}
			/>
		)
	}

	return {
		handleOpenSwitchWorkspaceDialog: handleOpen,
		handleCloseSwitchWorkspaceDialog: handleClose,
		renderSwitchWorkspaceDialog: render
	}
}
